import React from 'react'
import Typography from '@material-ui/core/Typography'
import {FormattedHTMLMessage} from 'react-intl'

const Footer = props => {
  const {name} = props
  const date = new Date().getFullYear()
  return (
    <Typography variant="caption" className="footer" align="center">
      <FormattedHTMLMessage
        id="allRightsReserved"
        values={{name: name, date: date}}
      />
    </Typography>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js